import { MemoExoticComponent } from 'react';
import { AsyncReturnType, PartialDeep } from 'type-fest';
import { AsyncFunction } from 'type-fest/source/async-return-type';

export enum LocalStorageKeys {
  VS_PORTAL_LOCALE = 'vs_portal_locale',
}

export type PortalLayoutMode = 'app' | 'doc';

export type PortalSideMenuBreakpoint = 'md' | 'lg';

export type PortalLayoutSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'full';

export enum SubscriptionStatus {
  TRIALING = 'trialing',
  TRIAL_PENDING_CANCELLED = 'trial_pending_cancelled',
  TRIAL_ENDED = 'trial_ended',
  ACTIVE = 'active',
  PENDING_PAYMENT = 'pending_payment',
  MISSING_PAYMENT = 'missing_payment',
  PENDING_CANCELLED = 'pending_cancelled',
  CANCELLED = 'cancelled',
  DIRECTLY_CANCELLED = 'directly_cancelled',
}

export type SsoPopupMsgPayload = {
  success: boolean;
  errorMsg: '' | 'invalid_client';
};

export type ComponentOfMemo<T> =
  T extends MemoExoticComponent<infer P> ? P : unknown;

export type PartialDeepReturnValue<F extends (...args: never[]) => unknown> =
  PartialDeep<ReturnType<F>>;

export type PartialDeepReturnValueFunc<
  F extends (...args: never[]) => unknown,
> = (
  ...args: Parameters<F>
) => PartialDeep<ReturnType<F>, { recurseIntoArrays: true }>;

export type PartialDeepAsyncReturnValueFunc<F extends AsyncFunction> = (
  ...args: Parameters<F>
) => Promise<PartialDeep<AsyncReturnType<F>, { recurseIntoArrays: true }>>;
